'use strict';

/**
 * Used to be a jquery-ui datepicker, but that library was ditched
 */
angular.module('clientDashboardApp').directive('jqdatepicker', function (uibDateParser) {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        placeholder: '@',
        format: '=',
        required: '=',
        minDate: '='
      },
      template: 
      `<input type="text" 
          class="form-control"
          ng-model="date"
          placeholder="{{placeholder}}"
          ng-click="isOpen = true"
          ng-change="updateModel()"
          is-open="isOpen"
          show-button-bar="false"
          datepicker-options="{showWeeks: false,minDate:minDate || null}"
          uib-datepicker-popup="{{format}}"
        />`,
        link(scope, element) {
          scope.format = scope.format || 'yyyy-MM-dd';
          scope.options = {showWeeks: false};
          let dateParsed,uibParsed,parsedDate = null

          refreshDate()

          scope.$watch('ngModel',(newVal,oldVal) => {
            if(newVal !== oldVal) {
              refreshDate()
            }
          })

          function refreshDate() {
            dateParsed = new Date(scope.ngModel);
            uibParsed = uibDateParser.parse(scope.ngModel, scope.format);
            parsedDate = (dateParsed.getTime() || uibParsed) ? dateParsed || uibParsed : null
            scope.date = (parsedDate) ? new Date(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate()): null;
          }

          scope.updateModel = () => {
            scope.ngModel = element.children()[0].value;
          }

          if(scope.required){
            $(element).attr('required', 'required');
          }
        }
    };
});
